import createPinoLogger from 'pino';

import config from '#/config';
import { isClient } from '#/utils/general';

export function createLogger() {
  if (isClient()) {
    return createPinoLogger({
      level: process.env.LOG_LEVEL || 'info',
      browser: {
        asObject: true,
        disabled: config.environment !== 'local',
      },
    });
  }

  return createPinoLogger();
}

export default createLogger();
